import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 5c-3.866 0-7 3.134-7 7 0 .099.011.194.015.292C3.042 12.882 2 14.317 2 16c0 2.209 1.791 4 4 4h10.5c3.038 0 5.5-2.462 5.5-5.5 0-2.55-1.738-4.688-4.092-5.311C16.825 6.724 14.365 5 11.5 5zm0 2c1.982 0 3.778 1.175 4.577 2.993l.388.883.932.246C18.929 11.528 20 12.917 20 14.5c0 1.93-1.57 3.5-3.5 3.5H6c-1.103 0-2-.897-2-2 0-.818.494-1.545 1.259-1.852l1.312-.526-.058-1.412-.01-.166L6.5 12c0-2.757 2.243-5 5-5zM8 13l4 4 4-4h-2v-3h-4v3H8z",
    fill: "currentColor"
  }));
});